interface IStatusConfig {
  [status: string]: {
    text: string
    className: string
    style: React.CSSProperties
  }
}

import { useTranslation } from 'react-i18next'

const statusConfig: IStatusConfig = {
  progress: {
    text: 'my.filter.progress',
    className: 'text-primary-normal bg-primary-normal-10',
    style: {},
  },
  scheduled: {
    text: 'my.filter.scheduled',
    className: 'text-accent-mint',
    style: { backgroundColor: 'rgba(34, 197, 94, 0.10)' },
  },
  completed: {
    text: 'my.filter.completed',
    className: 'text-alternative',
    style: { backgroundColor: 'rgba(163, 163, 163, 0.08)' },
  },
}

const ProgressBadge = ({ status }: { status: string }) => {
  const { t } = useTranslation('common')
  return (
    <>
      {statusConfig[status] && (
        <div
          className={`${statusConfig[status]?.className} flex h-[28px] items-center justify-center rounded-lg px-2 text-[13px] font-medium lg:h-7 lg:px-2 lg:text-sm`}
          style={statusConfig[status]?.style}
        >
          {t(statusConfig[status]?.text)}
        </div>
      )}
    </>
  )
}

export default ProgressBadge
